// components/plScenario/table/AMIBreakdownSection.jsx
import React from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

const AMIBreakdownSection = ({
  isCollapsed,
  onToggle,
  amiBreakdown,
  months,
  quarters,
  viewMode,
  formatPercentage,
  formatCurrency,
}) => {
  const renderAMIRow = (label, getPercentage, goalPct = null, reverseColors = false) => {
    return (
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3 text-xs text-gray-700 border-b border-gray-200">
          {label}
        </td>
        
        {viewMode === 'monthly' ? (
          months.map((month) => {
            const pct = getPercentage(month.month_num);
            const isActualMonth = month.is_actual;
            
            let bgColorClass = 'bg-white';
            
            if (goalPct !== null) {
              const isOnTarget = Math.abs(pct - goalPct) <= 0;
              
              if (isOnTarget) {
                bgColorClass = isActualMonth ? 'bg-green-50' : 'bg-green-100';
              } else {
                const isTooHigh = pct > goalPct;
                
                if (reverseColors) {
                  bgColorClass = isTooHigh 
                    ? (isActualMonth ? 'bg-green-50' : 'bg-green-100')
                    : (isActualMonth ? 'bg-red-50' : 'bg-red-100');
                } else {
                  bgColorClass = isTooHigh 
                    ? (isActualMonth ? 'bg-red-50' : 'bg-red-100')
                    : (isActualMonth ? 'bg-green-50' : 'bg-green-100');
                }
              }
            } else {
              bgColorClass = isActualMonth ? 'bg-white' : 'bg-blue-50';
            }
            
            return (
              <td
                key={month.month_num}
                className={`px-2 py-3 text-center text-xs border-b border-gray-200 ${bgColorClass}`}
              >
                {formatPercentage(pct)}
              </td>
            );
          })
        ) : (
          quarters.map((quarter) => {
            const avgPct = quarter.months.reduce((sum, month) => {
              return sum + getPercentage(month.month_num);
            }, 0) / quarter.months.length;
            
            return (
              <td
                key={quarter.quarter}
                className="px-2 py-3 text-center text-xs border-b border-gray-200 bg-white"
              >
                {formatPercentage(avgPct)}
              </td>
            );
          })
        )}
        
        <td className="px-4 py-3 text-center text-xs bg-gray-50 border-b border-gray-200">
          {formatPercentage(
            months.reduce((sum, m) => sum + getPercentage(m.month_num), 0) / 12
          )}
        </td>
      </tr>
    );
  };

  return (
    <>
      <tr 
        className="bg-brightblue-500 font-bold cursor-pointer"
        onClick={onToggle}
      >
        <td colSpan={14} className="py-3 px-4 text-white text-xs">
          <span className="inline-block mr-2">
            {isCollapsed ? (
              <ChevronRightIcon className="w-4 h-4 inline" />
            ) : (
              <ChevronDownIcon className="w-4 h-4 inline" />
            )}
          </span>
          AMI Breakdown
        </td>
      </tr>

      {!isCollapsed && (
        <>
          {renderAMIRow('Labor Costs - Goal 55%', (m) => amiBreakdown[m].laborCostsPct, 55)}
          {renderAMIRow('Total Expenses/Overhead - Goal 25%', (m) => amiBreakdown[m].overheadPct, 25)}
          {renderAMIRow('Profit - Goal 20%', (m) => amiBreakdown[m].profitPct, 20, true)}
          {renderAMIRow('Net Income %', (m) => amiBreakdown[m].netIncomePct)}
        </>
      )}
    </>
  );
};

export default AMIBreakdownSection;